"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAPI = void 0;
const base_1 = require("../base");
class SearchAPI extends base_1.BaseAPI {
    /**
     * Search for companies.
     *
     * @see https://developers.themoviedb.org/3/search/search-companies
     */
    async companies(filters) {
        const path = this.getPath('/search/company', filters);
        return this.get(path);
    }
    /**
     * Search for collections.
     *
     * @see https://developers.themoviedb.org/3/search/search-collections
     */
    async collections(filters) {
        const path = this.getPath('/search/collection', filters);
        return this.get(path);
    }
    /**
     * Search for keywords.
     *
     * @see https://developers.themoviedb.org/3/search/search-keywords
     */
    async keywords(filters) {
        const path = this.getPath('/search/keyword', filters);
        return this.get(path);
    }
    /**
     * Search for movies.
     *
     * @see https://developers.themoviedb.org/3/search/search-movies
     */
    async movies(filters) {
        const path = this.getPath('/search/movie', filters);
        return this.get(path);
    }
    /**
     * Search multiple models in a single request. Multi search currently supports searching for
     * movies, tv shows and people in a single request.
     *
     * @see https://developers.themoviedb.org/3/search/multi-search
     */
    async multiSearch(filters) {
        const path = this.getPath('/search/multi', filters);
        return this.get(path);
    }
    /**
     * Search for people.
     *
     * @see https://developers.themoviedb.org/3/search/search-people
     */
    async people(filters) {
        const path = this.getPath('/search/person', filters);
        return this.get(path);
    }
    /**
     * Search for a TV show.
     *
     * @see https://developers.themoviedb.org/3/search/search-tv-shows
     */
    async tvShows(filters) {
        const path = this.getPath('/search/tv', filters);
        return this.get(path);
    }
}
exports.SearchAPI = SearchAPI;
